<template>
  <div class="homeBox">
    <CGaode @mapLoaded="mapLoaded" :mapData="mapData" style="width: 100%; height: 100%"></CGaode>
    <div class="parkPoint flex" v-if="pointShow">
      <div class="pointContent flex">
        <div class="titleBox flexR">
          <span>{{ markertObj.parkingName || '' }}</span>
          <div class="distance">
            <img :src="require('@/assets/home/distance.png')" class="img" />{{ markertObj.distance || 0 }} km
          </div>
        </div>

        <div class="address span-overflow2">{{ markertObj.parkingAddress }}</div>
        <div class="numBox">
          <div class="numItem empty">
            剩余车位
            <span
              :class="[
                'emptyNum',
                markertObj.warningColor === '红' ? 'red' : markertObj.warningColor === '黄' ? 'yellow' : '',
              ]"
              >{{ markertObj.parkingMargin || 0 }}</span
            >
          </div>
          <div class="numItem">
            总车位 <span>{{ markertObj.parkingNumber || 0 }}</span>
          </div>
        </div>
      </div>
      <div class="btnBox">
        <div class="btn flexR" @click="pointShow = false">取消</div>
        <div class="btn flexR" @click="dhClick(markertObj)">导航</div>
      </div>
    </div>
    <Navigation v-if="showKey" :showKey="showKey" :dhObj="dhObj" @onConfirm="showKey = false"></Navigation>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import { Toast } from 'vant'
import gaodeUtils from '@/utils/gaodeUtils'
import { getFlatternDistance } from '@/utils/distance'
import { PList } from './data.js'
import { parkingListH5 } from '@/api/index'
let map = null
let AMap = null
export default {
  data() {
    return {
      mapData: {
        viewMode: '2D', // 默认使用 2D 模式，如果希望使用带有俯仰角的 3D 模式，请设置 viewMode: '3D',
        center: [120.850811, 30.378648], //初始化地图中心点
        resizeEnable: true,
        zoom: 15,
        doubleClickZoom: false,
        buildingAnimation: true, //楼块出现是否带动画
      },
      // noticText: '',

      parkShow: false,
      pointShow: false,
      parkList: [],
      markertObj: {
        parkingName: '',
      },
      latitudeMain: null,
      longitudeMain: null,
      // latitudeMain: 30.74744,
      // longitudeMain: 120.78483,
      markerDataList: [], //地图撒点数据
      showKey: false,
      dhObj: null,
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.parkShow = false
    this.pointShow = false
  },
  methods: {
    //地图初始
    mapLoaded() {
      map = gaodeUtils.getMap()
      AMap = gaodeUtils.getAMap()
      // HTML5定位
      if (navigator.geolocation) {
        this.getPosition()
      } else {
        console.log('Geolocation API不受支持')
      }
      this.getList()
    },

    handleLocationError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          // Toast('您拒绝了位置共享请求。请检查您的浏览器设置，以允许位置共享。')
          this.getPosition()
          break
        case error.POSITION_UNAVAILABLE:
          Toast('位置信息不可用。')
          break
        case error.TIMEOUT:
          Toast('请求位置超时。')
          break
        case error.UNKNOWN_ERROR:
          Toast('发生未知错误。')
          break
      }
    },

    getPosition() {
      map = gaodeUtils.getMap()
      AMap = gaodeUtils.getAMap()
      AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 1000 * 30, //超过10秒后停止定位，默认：5s
          position: 'RB', //定位按钮的停靠位置
          offset: [10, 20], //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
          zoomToAccuracy: false, //定位成功后是否自动调整地图视野到定位点
          showButton: false,
          panToLocation: false,

          circleOptions: {
            radius: 0,
            strokeColor: 'transparent',
            fillColor: 'transparent',
          },
        })
        map.addControl(geolocation)
        geolocation.getCurrentPosition(function (status, result) {
          if (status == 'complete') {
            console.log('1111111111111')

            let icon = new AMap.Icon({
              size: new AMap.Size(40, 40),
              image: '/h5/img/map.png',
              imageSize: new AMap.Size(40, 40),
              imageOffset: new AMap.Pixel(-0, -0),
            })
            let marker = new AMap.Marker({
              icon: icon,
              position: new AMap.LngLat(result.position.lng, result.position.lat),
              offset: new AMap.Pixel(-20, -40),
            })
            map.add(marker)
          } else {
            console.log('error', result)
          }
        })
      })
    },

    async getList() {
      this.markerDataList.map((ite) => {
        map.remove(ite)
      })
      let data = await parkingListH5()

      PList.forEach((x) => {
        data.forEach((y) => {
          if (x.id === y.key) {
            x.parkingName = y.name
            x.parkingMargin = y.free
            x.parkingNumber = y.total
          }
        })
      })
      let dataMap = PList
      // 创建一个 Icon
      let icon = new AMap.Icon({
        size: new AMap.Size(34, 38),
        image: '/h5/img/park-map.png',
        imageSize: new AMap.Size(34, 38),
        imageOffset: new AMap.Pixel(-0, -0),
      })
      if (dataMap && dataMap.length) {
        let arr = dataMap
          .filter((ite) => ite.longitude && ite.latitude)
          .map((ite) => {
            return ite.longitude * 1 + ',' + ite.latitude * 1
          })
        // let center = this.getPointsCenter(arr)
        // map.setZoomAndCenter(this.mapData.zoom, [120.816, 30.802], false, 2000)
        // 撒点
        dataMap.map((ite) => {
          let marker = new AMap.Marker({
            icon: icon,
            position: new AMap.LngLat(ite.longitude * 1, ite.latitude * 1),
            offset: new AMap.Pixel(-17, -38),
            extData: ite,
          })
          marker.setLabel({
            offset: new AMap.Pixel(0, -2), //设置文本标注偏移量
            content: ite.parkingName, //设置文本标注内容
            direction: 'top', //设置文本标注方位
          })
          this.markerDataList.push(marker)
          // 将 markers 添加到地图
          map.add(marker)

          //鼠标点击marker弹出自定义的信息窗体
          AMap.event.addListener(marker, 'click', (e) => {
            console.log(e, e.target.getExtData(), 'marker点击')
            let obj = e.target.getExtData()
            this.markerClick(obj)
          })
        })
        map.setFitView(this.markerDataList)
      }
    },

    // 停车场详情
    async getParkInfo(obj) {
      let data = { ...obj }
      const cal = getFlatternDistance(
        this.latitudeMain * 1,
        this.longitudeMain * 1,
        data.latitude * 1,
        data.longitude * 1
      )
      const number = Math.round(cal)
      this.markertObj = { ...data, distance: (number / 1).toFixed(0) }
    },

    //markrer点击
    markerClick(e) {
      console.log(e, 'eeeeeeeeeeee')
      map.setZoomAndCenter(this.mapData.zoom, [e.longitude * 1, e.latitude * 1], false, 2000)
      this.pointShow = false
      this.getParkInfo(e)
      this.parkShow = false
      this.pointShow = true
    },
    parkClick(ite) {
      map.setZoomAndCenter(this.mapData.zoom, [ite.longitude * 1, ite.latitude * 1 - 0.01], false, 2000)
    },
    //导航事件
    dhClick(ite) {
      this.dhObj = { ...ite, parkingName: ite.poiName ? ite.poiName : ite.parkingName }
      this.showKey = true
    },
    //返回中心点的数组[精度,纬度]
    getPointsCenter(points) {
      var point_num = points.length //坐标点个数
      var X = 0,
        Y = 0,
        Z = 0
      for (let i = 0; i < points.length; i++) {
        if (points[i] == '') {
          continue
        }
        let point = points[i].split(',')
        var lat, lng, x, y, z
        lng = (parseFloat(point[0]) * Math.PI) / 180
        lat = (parseFloat(point[1]) * Math.PI) / 180
        x = Math.cos(lat) * Math.cos(lng)
        y = Math.cos(lat) * Math.sin(lng)
        z = Math.sin(lat)
        X += x
        Y += y
        Z += z
      }
      X = X / point_num
      Y = Y / point_num
      Z = Z / point_num

      var tmp_lng = Math.atan2(Y, X)
      var tmp_lat = Math.atan2(Z, Math.sqrt(X * X + Y * Y))

      return [(tmp_lng * 180) / Math.PI, (tmp_lat * 180) / Math.PI]
    },
  },
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  flex-direction: column;
}
.flexR {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.flexC {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.homeBox {
  width: 100vw;
  height: 100vh;
  .barBox {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 99;
  }
  .box {
    position: fixed;
    top: 50px;
    left: 12px;
    z-index: 99;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .tabBox {
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px 4px 4px 4px;
    .tabItem {
      // width: 100%;
      box-sizing: border-box;
      padding: 12px 12px 6px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      font-size: 11px;
      color: #636363;
      line-height: 19px;
      .img {
        width: 22px;
        height: 22px;
        margin-bottom: 3px;
      }
    }
    .selectItem {
      background: #19bdbf;
      color: #ffffff;
    }
  }
  .location {
    margin-top: 12px;
    width: 38px;
    height: 38px;
  }
  .tabBoxTop {
    .selectItem {
      border-radius: 4px 4px 0 0;
    }
  }
  .tabBoxBottom {
    .selectItem {
      border-radius: 0 0 4px 4px;
    }
  }
  .parkPoint {
    position: fixed;
    left: 12px;
    bottom: 12px;
    z-index: 99;
    width: 350px;
    background: #f7f5f5;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    justify-content: space-between;
    .pointContent {
      flex: 1;
      width: 100%;
      box-sizing: border-box;
      padding: 12px 14px;
      .titleBox {
        height: 29px;
        font-weight: 500;
        font-size: 20px;
        color: #1a1a1a;
        line-height: 29px;
        margin-bottom: 10px;
        .distance {
          display: flex;
          flex-direction: row;
          align-items: center;
          font-weight: 400;
          font-size: 13px;
          color: #19bdbf;
          line-height: 21px;
          .img {
            width: 15px;
            height: 15px;
            margin-right: 4px;
          }
        }
      }
      .address {
        width: 100%;
        font-size: 13px;
        color: #787878;
        line-height: 21px;
        margin-bottom: 18px;
      }
      .numBox {
        width: 100%;
        height: 21px;
        display: flex;
        vertical-align: bottom;
        font-size: 13px;
        color: #787878;
        line-height: 21px;
        span {
          font-weight: 500;
          font-size: 20px;
          color: #636363;
          margin-left: 8px;
        }
        .numItem {
          &:nth-child(1) {
            &::after {
              content: '';
              display: inline-block;
              height: 15px;
              width: 1px;
              background: #d8d8d8;
              margin: 0 32px;
            }
          }
        }
        .emptyNum {
          color: #19bdbf;
        }
        .yellow {
          color: #f6bd00;
        }
        .red {
          color: #e43131;
        }
      }
    }

    .btnBox {
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      .btn {
        height: 100%;
        font-size: 16px;
        color: #2a2a2a;
        justify-content: center;
        &:nth-child(1) {
          width: 120px;
          background: #e4e4e4;
          border-radius: 0px 0px 0 4px;
        }
        &:nth-child(2) {
          flex: 1;
          color: #ffffff;
          background: #19bdbf;
          border-radius: 0px 0px 4px 0px;
        }
      }
    }
  }

  .popupcontent {
    width: 100%;
    height: 450px;
    background: #f7f5f5;
    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px 12px 0px 0px;
    box-sizing: border-box;
    padding: 12px;
    position: fixed;
    bottom: 0;
    z-index: 99;
    display: flex;
    flex-direction: column;

    .popupTitle {
      box-sizing: border-box;
      width: 100%;
      height: 25px;
      box-sizing: border-box;
      padding: 0 4px;
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 500;
      font-size: 15px;
      color: #0f1114;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 28px;
      .title {
        flex: 1;
        width: 0;
      }
      .closeImg {
        width: 20px;
        height: 20px;
      }
    }
    .popupBox {
      flex: 1;
      height: 0;
      overflow-y: auto;
      padding-bottom: 24px;
    }
  }
}
::v-deep .amap-marker-label {
  background: rgba(20, 20, 20, 0.8) !important;
  border-radius: 119px 119px 119px 119px !important;
  border: none !important;
  font-size: 11px !important;
  color: #ffffff !important;
  padding: 3px 5px !important;
}
</style>
